var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from '@/events/AppEvents';
import { Apphandler } from '@/ipc/MainAppHandler';
import { ProjectObjectType } from '@@/Project';
import { Box, Flex, FormControl, FormLabel, Icon, Input, Text } from '@chakra-ui/react';
import { action, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { SketchPicker } from 'react-color';
import { FaFolder } from '@react-icons/all-files/fa/FaFolder';
import { ScaleLoader } from 'react-spinners';
import { BaseDialog, BaseDialogState } from './BaseDialog';
export class ProjectNewFolderState {
    constructor() {
        this.basedialogState = new BaseDialogState();
        this.name = "";
        this.loading = false;
        this.activefolderid = "";
        this.activeletrid = "";
        this.color = "orange";
        makeObservable(this);
        this.basedialogState.setCancelLabel("Cancel");
        this.basedialogState.setOkLabel("Create");
        this.basedialogState.setHeaderLabel("New Folder");
        this.basedialogState.setDisableOkButton(true);
        this.basedialogState.onClose = () => this.setOpen(false);
        this.basedialogState.onOk = () => this.createFolder();
        APPEvent.addSubscriberForCreateObject((ob) => {
            if (this.loading && ob.letrid === this.activeletrid) {
                if (ob.project !== undefined) {
                    APPEvent.publishProjectObject(ob.project);
                    this.setOpen(false);
                }
                else {
                    APPEvent.publishApperror("Sorry failed to create folder");
                }
                this.setLoading(false);
            }
        });
    }
    setColor(color) {
        this.color = color;
    }
    setLoading(loading) {
        this.loading = loading;
    }
    setOpen(open) {
        this.basedialogState.setOpen(open);
        if (open) {
            this.setName("");
        }
    }
    setName(name) {
        this.name = name;
        if (!this.name.trim()) {
            this.basedialogState.setDisableOkButton(true);
        }
        else {
            this.basedialogState.setDisableOkButton(false);
        }
    }
    async createFolder() {
        if (!this.name.trim()) {
            return;
        }
        // lets create this object
        this.setLoading(true);
        const bfolder = {
            id: "",
            name: this.name,
            parentid: this.activefolderid,
            childrencount: 0,
            updatetime: 0,
            type: ProjectObjectType.Folder,
            color: this.color,
            accessids: []
        };
        console.log(bfolder);
        const req = {
            letrid: this.activeletrid,
            project: bfolder
        };
        Apphandler.sendMessage("createproject", req);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectNewFolderState.prototype, "name", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectNewFolderState.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ProjectNewFolderState.prototype, "color", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ProjectNewFolderState.prototype, "setColor", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ProjectNewFolderState.prototype, "setLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ProjectNewFolderState.prototype, "setName", null);
let ProjectNewFolder = class ProjectNewFolder extends React.Component {
    constructor(prop) {
        super(prop);
    }
    pickedColor(hex) {
        this.props.state.setColor(hex);
    }
    dialog() {
        return React.createElement(Box, null,
            React.createElement(FormControl, { id: 'folder-name' },
                React.createElement(FormLabel, null, "Name"),
                React.createElement(Input, { onChange: (e) => this.props.state.setName(e.currentTarget.value), type: 'text', value: this.props.state.name })),
            React.createElement(Flex, { mt: '10px' },
                React.createElement(Text, { mr: '10px', fontWeight: 'bold' }, "Folder Color: "),
                React.createElement(Box, null,
                    React.createElement(Icon, { as: FaFolder, color: this.props.state.color, w: '20px', h: '20px' }),
                    React.createElement(Box, { mt: '10px' },
                        React.createElement(SketchPicker, { color: this.props.state.color, onChange: ({ hex }) => this.pickedColor(hex) })))),
            this.props.state.loading && React.createElement(Flex, { mt: '20px', align: 'center', justify: 'center', w: '100%' },
                React.createElement(ScaleLoader, { color: 'green' })));
    }
    render() {
        return (React.createElement(BaseDialog, { body: this.dialog(), state: this.props.state.basedialogState }));
    }
};
ProjectNewFolder = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], ProjectNewFolder);
export { ProjectNewFolder };
